import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {BillingInformation, Country, Order} from "../../../../store/state/order.state";
import {ContactPersonComponent} from "../../contact-person/contact-person.component";
import {CompanyAddressComponent} from "../../company-address/company-address.component";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";
import {Actions, ofType} from "@ngrx/effects";
import {AuthenticationService} from "../../../../authentication/authentication.service";
import {deepCopy, deepEqual} from "../../../../umbrella-common/common-functions";
import {OrderActions} from "../../../../store/actions/order.actions";
import {NavigationActions} from "../../../../store/actions/navigation.actions";
import {BillingInfoFormService} from "./billing-info-form.service";
import {EndpointsProvider} from "../../../../umbrella-common/endpoints/endpoint-provider.service";
import {NotificationService} from "../../../../umbrella-common/services/notification.service";

@Component({
    selector: 'billing-info-edit',
    templateUrl: './billing-info-edit.template.html',
    styleUrls: ['./billing-info-edit.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BillingInfoEditComponent implements OnInit {

	@Input() order: Order;
	@Input() countries: Country[];
	@Input() showDecisionButtons = true;
	@Input() collapsable = false;

	@Output() changesCanceled: EventEmitter<any> = new EventEmitter<any>();
	@Output() changesSaved: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild(ContactPersonComponent, {static: false}) contactPersonComponent: ContactPersonComponent;
	@ViewChild(CompanyAddressComponent, {static: false}) companyAddressComponent: CompanyAddressComponent;

	actionInProgress: boolean = false;
	billingVisible = true;
	originalBillingInformation: BillingInformation;

	constructor(private formService: BillingInfoFormService, private store: Store<AppState>, private actions$: Actions, private endpoints: EndpointsProvider,
				private notifications: NotificationService, private authService: AuthenticationService) {
	}

	ngOnInit() {
		this.originalBillingInformation = deepCopy(this.order.billingInformations) as BillingInformation;

		this.actions$.pipe(ofType(OrderActions.CHANGE_BILLING_INFORMATION_SUCCESS)).subscribe(response => {
			this.actionInProgress = false;
			this.changesSaved.emit(response.order.orderCorrelationId);
		});

		this.actions$.pipe(ofType(OrderActions.CHANGE_BILLING_INFORMATION_FAILURE)).subscribe(_ => {
			this.actionInProgress = false;
			this.formService.enableInputs();
			this.notifications.error();
			setTimeout(() => {
				if (this.authService.isLoggedUserClient(false)) {
					this.store.dispatch(NavigationActions.GO_TO_ERROR_PAGE());
				} else {
					this.store.dispatch(NavigationActions.GO_TO_LOGIN_PAGE());
				}
			}, 1500);
		});
	}

	cancel() {
		this.actionInProgress = true;
		this.endpoints.common.getOrder(this.order.orderCorrelationId).subscribe(order => {
			this.store.dispatch(OrderActions.SET_BILLING_INFORMATIONS({billingInformations: order.billingInformations}));
			this.actionInProgress = false;
			this.changesCanceled.emit();
		});
	}

	saveChanges() {
		this.formService.submit(() => {
			this.actionInProgress = true;
			this.store.dispatch(OrderActions.CHANGE_BILLING_INFORMATION({
				correlationId: this.order.orderCorrelationId,
				billingInformationsRequest: {
					...this.formService.getBillingInformationFor(this.order),
					billingContactPerson: this.contactPersonComponent ? this.contactPersonComponent.getContactPerson() : null,
					billingCompany: this.companyAddressComponent ? this.companyAddressComponent.getCompanyAddress() : null
				}
			}));
		});
	}

	isChanged(): boolean {
		return !deepEqual(this.originalBillingInformation, this.order.billingInformations);
	}
}
